import React from "react";
import { TChaseReasons } from "../../../../../domain/codecs/Cases";
import { CRMIcon } from "../../CRMIcon/CRMIcon";
import { CRMColors } from "../../../models/CRMColors";
import { ChaseReasons_displayString } from "../../../../../domain/codecs/Cases";

type TCRMCaseChaseBannerProps = {
    chaseReasons: Array<TChaseReasons>;
    daysInChase: number;
    onReview: () => void;
};

const daysInChaseLabel = (days: number): string =>
    days <= 0 ? "In chase since today"
    : days === 1 ? "In chase for 1 day"
    : `In chase for ${days} days`;

export const CRMCaseChaseBanner = (props: TCRMCaseChaseBannerProps): JSX.Element => (
    <div className="crm-case-chase-banner">
        <div className="crm-case-chase-banner__icon">
            <CRMIcon
                iconName="pause"
                size="20px"
                colour="hex"
                hexColour={CRMColors.HIGHLIGHTS_CALMING_PINK_0}
            />
        </div>

        <div className="crm-case-chase-banner__body">
            <div className="crm-case-chase-banner__header">
                <div className="crm-case-chase-banner__title">
                    This case is in chase
                </div>
                <div
                    className="crm-case-chase-banner__review"
                    onClick={props.onReview}
                >
                    Review / update
                </div>
            </div>

            <div className="crm-case-chase-banner__duration">
                {daysInChaseLabel(props.daysInChase)}
            </div>

            {props.chaseReasons.length > 0 &&
                <div className="crm-case-chase-banner__reasons">
                    {props.chaseReasons.map((reason) => (
                        <div
                            key={reason}
                            className="crm-case-chase-banner__reason"
                        >
                            {ChaseReasons_displayString(reason)}
                        </div>
                    ))}
                </div>
            }
        </div>
    </div>
);
